const MOBILE_BREAKPOINT = 850;
const SMALL_DESKTOP = 1125;

export const BREAKPOINTS = {
  mobile: MOBILE_BREAKPOINT,
  mobilePx: `${MOBILE_BREAKPOINT}px`,
  smallDesktop: SMALL_DESKTOP,
  smallDesktopPx: `${SMALL_DESKTOP}px`,
};
